import { makeAutoObservable, runInAction } from "mobx";
import { VideoEditingConfigType, VideoGenerationResponse, defaultVideoConfig } from "../../../models/video-editing";
import QueryService from "../../../utils/QueryService";
import { IPlaygroundStore } from "../../Playground/store/playground-store";

export interface IVideoEditingStore {
	config: VideoEditingConfigType;

	loadingGenerate: boolean;

	handleConfigChange: <K extends keyof VideoEditingConfigType>(key: K, value: VideoEditingConfigType[K]) => void;
	generateVideo: (config: VideoEditingConfigType) => Promise<VideoGenerationResponse>;
}

export class VideoEditingStore implements IVideoEditingStore {
	private queryService: QueryService = new QueryService("/video-editing");
	playgroundStore: IPlaygroundStore;

	config: VideoEditingConfigType = defaultVideoConfig;

	loadingGenerate: boolean = false;

	constructor(playgroundStore: IPlaygroundStore) {
		makeAutoObservable(this);
		this.playgroundStore = playgroundStore;
	}

	handleConfigChange = <K extends keyof VideoEditingConfigType>(key: K, value: VideoEditingConfigType[K]) => {
		runInAction(() => {
			this.config = { ...this.config, [key]: value };
		});
	};

	generateVideo = async (config: VideoEditingConfigType): Promise<VideoGenerationResponse> => {
		try {
			this.loadingGenerate = true;
			const response: VideoGenerationResponse = await this.queryService.post(`/`, config);
			runInAction(() => {
				this.loadingGenerate = false;
				this.playgroundStore.playgroundResults = [...this.playgroundStore.playgroundResults];
			});

			return response;
		} catch (err: any) {
			this.loadingGenerate = false;
			return Promise.reject(err);
		}
	};
}
